import Blue from "~/core";

new Blue({
  name: 'Leaving Site Modal',
  selector: ".js-external-link",
  setup(modal) {
    const data = {
      copy: `You have clicked on a link which leaves the Options Industry<br>Conference website, and you will be redirected to a third party website.`,
      button: "Continue",
      close: "Nevermind, stay here",
      url: modal.href
    }
    const modalTemplate = `
    <div class="js-site-leave modal modal--is-active">
      <div class="modal__inner">
        <p class="modal__copy">${data.copy}</p>
        <a class="btn modal__button" href="${data.url}" target="_blank">${data.button}</a>
        <span class="js-close-modal modal__close">${data.close}</span>
		</div>
	</div>`
    this.$addEvents(modal, 'click.stop.prevent', function () {
      document.body.insertAdjacentHTML('afterend', modalTemplate)
      document.body.insertAdjacentHTML('afterend', '<div class="js-scrim modal__scrim"></div>')
      const modalLeave = document.querySelector('.js-site-leave')
      const modalScrim = document.querySelector('.js-scrim')
      const modalClose = modalLeave.querySelector('.js-close-modal')
      modalClose.addEventListener('click', function () {
        closeModal(modalLeave, modalScrim)
      })
    })

    function closeModal(modal, scrim) {
      modal.remove()
      scrim.remove()
    }
  }
});